import { createSelectCategoryContainer } from './container'
import { SelectCategoryUI } from './ui/select-category'

export const SelectCategoryPage = createSelectCategoryContainer(SelectCategoryUI)
